import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ListboxModule } from 'primeng/primeng';
import { DataTableModule, SharedModule, DialogModule, ButtonModule } from 'primeng/primeng';

import { HttpModule } from '@angular/http';

import { ContextService } from './services/context.service';
import { ApiService } from './services/api.service';
import { TimeService } from './services/time.service';
import { PeProviderService } from './services/pe-provider.service';
import { DataService } from './services/data.service';


import { AppComponent } from './app.component';
import { PlacesComponent } from './components/places/places.component';



import { APP_BASE_HREF } from '@angular/common';
import { environment } from '../environments/environment';


@NgModule({
  declarations: [
    AppComponent,
    PlacesComponent
  ],
  imports: [
    BrowserAnimationsModule, FormsModule, BrowserModule, ListboxModule, ButtonModule,
    HttpModule, DataTableModule, SharedModule, DialogModule
  ],
  providers: [
    { provide: APP_BASE_HREF, useValue: environment.baseRef },
    ContextService, ApiService, DataService, TimeService, PeProviderService],
  bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// /Users/sofos/projects/anadigit/kounoupia-data-entry/src/app/app.module.ts